module.exports = __webpack_public_path__ + "img/angelica.0cccd731.jpg";